import axios, { AxiosResponse } from 'axios';
import { getApiLink } from '../api';
import { iSnapGroup__API } from '../apiSchema';
import { useData } from '../hooks/useData';

export type UserGroup = iSnapGroup__API;

async function getGroups(): Promise<UserGroup[]> {
    const response: AxiosResponse<iSnapGroup__API[]> = await axios.get(getApiLink('User/GetSnapGroups'));

    return response.data;
}

export default function useGroups() {
    return useData([], getGroups);
}
